export * from './src/datepicker.module';



// WEBPACK FOOTER //
// ./~/angular2-material-datepicker/index.ts